export enum TipoEntidadeEnum {
    Nenhum = 0,
    AutoridadeCertificadora = 1,
    AutoridadeRegistro = 2,
    LocalAtendimento = 4,
}
